import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'How often should I get my eyes checked?',
  answer: 'For most adults, a comprehensive eye exam is recommended every 1-2 years. However, if you wear glasses/contacts, have a family history of eye disease, or have conditions like diabetes, you may need annual or more frequent exams.'
}, {
  question: 'Do you accept my vision insurance?',
  answer: 'We accept most major vision and medical insurance plans. Please call our office with your insurance details so we can verify your coverage before your appointment.'
}, {
  question: 'At what age should my child have their first eye exam?',
  answer: "The American Optometric Association recommends a child's first eye exam at 6 months of age, followed by exams at age 3, and before starting first grade (age 5 or 6)."
}, {
  question: 'What should I bring to my appointment?',
  answer: 'Please bring your current glasses or contact lenses, a list of any medications you are taking, your vision and medical insurance cards, and a valid photo ID.'
}, {
  question: 'Do you treat eye emergencies?',
  answer: 'Yes, we handle eye emergencies such as pink eye, foreign body removal, sudden vision loss, and eye pain. If you are experiencing an emergency during office hours, please call us immediately.'
}, {
  question: 'How long does a comprehensive eye exam take?',
  answer: 'A standard comprehensive eye exam usually takes between 30 to 45 minutes. If you are being fitted for contact lenses or require dilation, the appointment may take up to an hour.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-20 md:py-28 bg-surface-muted" data-id="element-170">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        <div className="text-center mb-12" data-id="element-172">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-section-mobile md:text-section text-brand-dark mb-4" data-id="element-173">
            Frequently Asked Questions
          </motion.h2>
        </div>

        <div className="space-y-4" data-id="element-174">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-card shadow-sm overflow-hidden border border-gray-100" data-id="element-175">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus-ring" aria-expanded={openIndex === index} aria-controls={`faq-answer-${index}`} data-id="element-176">
                <span className="font-heading font-semibold text-brand-dark pr-4" data-id="element-177">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-178" />
              </button>

              <AnimatePresence data-id="element-179">
                {openIndex === index && <motion.div id={`faq-answer-${index}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-180">
                    <div className="px-6 pb-5 text-neutral-text/70 leading-relaxed border-t border-gray-50 pt-4" data-id="element-181">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}